// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3755Q","title":"Header_title__Eazo9","left":"Header_left__pbmjY","clinicName":"Header_clinicName__2cCf-"};